var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-header"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png")},on:{"click":_vm.jumpSite}}),_c('h1',{staticClass:"title"},[_vm._v("柏悦众诚模板展示中心")])])
}
var staticRenderFns = []

export { render, staticRenderFns }